module.exports = __webpack_public_path__ + "img/201805-4.add83d93.jpeg";